export const buttonWrapper ="w-full mb-3 rounded-md"
export const buttonMain ="w-full flex items-center justify-between p-3"
export const buttonText = "font-semibold"
export const spinner= "absolute inset-0 flex items-center justify-center"